/* __next_internal_client_entry_do_not_use__ Default,default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withStandardComponentWrapper } from 'helpers/HOC';
import { tv } from 'tailwind-variants';
import { EditingFieldValues } from 'helpers/Editing/EditingFieldValues';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import useDictionary from 'lib/hooks/useDictionary';
import useIsEditing from 'lib/hooks/useIsEditing';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const InlineIFrame = (props)=>{
    const { embedUrl, title } = props?.fields || {};
    const { width, height, aspectRatio } = props?.params || {};
    const { iframe: iframeClass, iframeWrapper } = TAILWIND_VARIANTS({});
    const { getDictionaryValue } = useDictionary();
    const isEditing = useIsEditing();
    if (!embedUrl?.value && isEditing) {
        return /*#__PURE__*/ _jsx(EditingHelpText, {
            priority: "warning",
            children: getDictionaryValue('EmbedURLUnavailable') || 'No url available'
        });
    }
    const iframeHeight = aspectRatio || !width || width === '100%' ? '100%' : height || '500px';
    return /*#__PURE__*/ _jsxs("section", {
        className: iframeWrapper(),
        "data-component": "authorable/shared/media/inlineiframe",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`iframe-wrapper`),
        children: [
            /*#__PURE__*/ _jsx(EditingFieldValues, {
                hasRenderingParams: true,
                fields: [
                    {
                        label: 'Embed URL',
                        field: embedUrl
                    },
                    {
                        label: 'Title (For Screen Readers)',
                        field: title
                    }
                ]
            }),
            embedUrl?.value && /*#__PURE__*/ _jsx("iframe", {
                className: iframeClass(),
                title: title?.value?.trim() || 'Embedded content',
                "aria-label": title?.value?.trim() || 'Embedded content',
                src: embedUrl?.value,
                width: width || '100%',
                height: iframeHeight,
                style: {
                    aspectRatio: aspectRatio || 16 / 9
                },
                sandbox: "allow-same-origin allow-scripts allow-presentation",
                referrerPolicy: "no-referrer",
                ...getTestProps(`iframe`)
            })
        ]
    });
};
export const Default = withStandardComponentWrapper(InlineIFrame);
export default Default;
const TAILWIND_VARIANTS = tv({
    slots: {
        iframeWrapper: [
            'px-2',
            'lg:px-0',
            'flex'
        ],
        iframe: [
            'mx-auto'
        ]
    }
});
